import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  List,
  SwipeableDrawer,
  Typography,
  useTheme,
} from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import { setOpenAuthSidebar } from "../../../../redux/features/settingSlice";
import LogoSe from "../../../../media/images/icons/logoSecondary.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomListItem from "./components/ListItem";
import GuidIcon from "../../../../media/images/icons/guidIcon.svg";
import LearnVideoIcon from "../../../../media/images/icons/LearnVideoIcon.svg";
import TermsIcon from "../../../../media/images/icons/TermsIcon.svg";
import NotifIcon from "../../../../media/images/icons/NotifIcon.svg";
import HomeIcon from "../../../../media/images/icons/HomeIcon.svg";
import LoginSVG from "../../../../media/images/icons/login-newsvg";
import UserRegister from "../../../../media/images/icons/userRegister";
import CallIcon from "../../../../media/images/icons/call.svg";
import CustomAccordion from "./components/Accordion";
import ThemeToggle from "../../../components/ThemeToggle";

export default function AuthSidebar() {
  const { authSidebar } = useAppSelector((state) => state.setting);
  const dispatch = useAppDispatch();

  const theme = useTheme();

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      dispatch(setOpenAuthSidebar(open));
    };

  return (
    <Box>
      <SwipeableDrawer
        dir="rtl"
        sx={{
          "& .MuiPaper-root": {
            width: 270,
            position: "absolute",
            bgcolor: "primary.light",
            right: "0px",
            top: "0px",
            bottom: "0px",
            height: "auto",
            // borderRadius: "15px",
            display: "flex",
            flexDirection: "column",
            gap: 3,
            paddingX: "10px",
            paddingY: "8px",
          },
        }}
        anchor="right"
        open={authSidebar}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography>ورژن 1.0.0</Typography>

          <ThemeToggle />
        </Box>

        <Box
          sx={{
            backgroundColor: "background.default",
            // border: "1px solid gray",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "6px",
              paddingY: "8px",
            }}
          >
            <img width={70} src={LogoSe} alt="" />
            <Typography
              sx={{
                color: "secondary.dark",
                fontWeight: "bolder",
              }}
            >
              کارن ترابرنت
            </Typography>
          </Box>

          <Box
            sx={{
              width: "100%",
              maxWidth: 360,
              overflow: "hidden",
              gap: "8px",
              display: "flex",
              flexDirection: "column",
              padding: "0px 8px 16px 8px",
            }}
            dir="rtl"
          >
            <nav aria-label="main mailbox folders">
              <List>
                <CustomListItem
                  path="/dashboard"
                  title="پیشخوان"
                  icon={HomeIcon}
                />
              </List>
            </nav>
            <CustomAccordion
              Icon={<UserRegister color={theme.palette.textColor.main} />}
              title="ثبت نام"
            />
            <CustomAccordion
              Icon={<LoginSVG color={theme.palette.textColor.main} />}
              title="ورود به حساب"
            />
            {/* <CustomAccordion icon="" title="ورود به حساب" /> */}
          </Box>
        </Box>
        <Box
          sx={{
            backgroundColor: "background.default",
            // border: "1px solid gray",
            borderRadius: "10px",
            width: "100%",
            maxWidth: 360,
          }}
        >
          <nav
            style={{
              padding: "0px 8px",
            }}
            aria-label="main mailbox folders"
          >
            <List
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <CustomListItem path="/guides" title="راهنما" icon={GuidIcon} />
              <Divider variant="middle" />
              <CustomListItem
                path="/courses"
                title="آموزش ویدئویی"
                icon={LearnVideoIcon}
              />
              <Divider variant="middle" />
              <CustomListItem path="/terms" title="قوانین" icon={TermsIcon} />
              <Divider variant="middle" />
              <CustomListItem
                path="/notifs"
                title="اعلان‌ها"
                icon={NotifIcon}
              />
              <Divider variant="middle" />
              <CustomListItem
                path="/aboutus"
                title="درباره کارن ترابرنت"
                icon={TermsIcon}
              />
            </List>
          </nav>
        </Box>
        <Box
          sx={{
            backgroundColor: "background.default",
            // border: "1px solid gray",
            borderRadius: "10px",
            padding: "16px",
            width: "100%",
            maxWidth: 360,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img width={20} src={CallIcon} alt="" />
            <Typography
              sx={{
                fontWeight: "600",
              }}
            >
              شماره تماس مرکز:
            </Typography>
          </Box>
          <Typography
            sx={{
              fontWeight: "600",
            }}
          >
            07633452480-3
          </Typography>
        </Box>
      </SwipeableDrawer>
    </Box>
  );
}
